module.exports = function(selector)
{
    var plannerElement = document.querySelector(selector);
    var entryWrapperElement = plannerElement.querySelector('.production-plan-entries');
    var template = plannerElement.querySelector('.production-plan-entry.template');

    var entryTemplate = template ? template.cloneNode(true) : null;
    var removeEntryButton = entryTemplate.querySelector('.remove-plan');

    var existingEntries = plannerElement.querySelectorAll('.production-plan-entry.existing');
    if (existingEntries)
    {
        for(var i = 0; i < existingEntries.length; i++)
        {
            entry = existingEntries[i];
            
            var removeButton = entry.querySelector('.remove-plan');
            removeButton.disabled = false;

            registerRemoveEntryButton(removeButton, entry);
        }
    }

    if (template)
    {
        template.parentElement.removeChild(template);
    }

    if (entryTemplate)
    {
        entryTemplate.classList.add('collapsed');
        entryTemplate.classList.remove('template');
    }

    if (removeEntryButton)
    {
        removeEntryButton.classList.add('btn-danger');
        removeEntryButton.disabled = false;
    }

    function registerRemoveEntryButton(button, entryElement)
    {
        button.addEventListener('click', function(e)
        {
            removeEntry(entryElement);
        });
    }

    function addEntry(isFirst)
    {
        var entryElement = entryTemplate.cloneNode(true);
        entryWrapperElement.appendChild(entryElement);

        registerRemoveEntryButton(entryElement.querySelector('.remove-plan'), entryElement);

        var containerCountField = entryElement.querySelector('input[name="container_count"]');

        var keyupListener = function() 
        {
            containerCountField.removeEventListener('keyup', keyupListener);
            addEntry();
            return true;
        };

        containerCountField.addEventListener('keyup', keyupListener);

        setTimeout(function() {
            entryElement.classList.remove('collapsed');

            if (isFirst)
            {
                containerCountField.focus();
            }
        }, 1);
    }

    function removeEntry(entryElement)
    {
        var onTransitionEnd = function()
        {
            entryElement.removeEventListener('transitionend', onTransitionEnd);
            entryWrapperElement.removeChild(entryElement);
        };

        entryElement.addEventListener('transitionend', onTransitionEnd);
        entryElement.classList.add('collapsed');
    }

    var insertButton = plannerElement.querySelector('.insert-plan');
    if (insertButton)
    {
        insertButton.addEventListener('click', function(e)
        {
            addEntry();
        });

        insertButton.disabled = false;
    }

    var deleteButton = plannerElement.querySelector('.delete-plan');
    if (deleteButton)
    {
        deleteButton.addEventListener('click', function(e)
        {
            e.preventDefault();
            swal({
                title: "Are you sure?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                closeOnConfirm: true
            }, function () {
                window.location = deleteButton.getAttribute('data-href');
            });
        });

        deleteButton.disabled = false;
    }

    var saveButton = plannerElement.querySelector('.save-plan');
    if (saveButton)
    {
        saveButton.disabled = false;
    }

    if (plannerElement)
    {
        plannerElement.classList.remove('loading');
    }

    // Add one empty row
    addEntry(true);
}